import { render } from "./FirstTimeSection.vue?vue&type=template&id=20899452&scoped=true"
import script from "./FirstTimeSection.vue?vue&type=script&lang=js"
export * from "./FirstTimeSection.vue?vue&type=script&lang=js"

import "./FirstTimeSection.vue?vue&type=style&index=0&id=20899452&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20899452"]])

export default __exports__